import { render, staticRenderFns } from "./EquipamentoTemplateIndex.vue?vue&type=template&id=68ac5c38&"
import script from "./EquipamentoTemplateIndex.vue?vue&type=script&lang=js&"
export * from "./EquipamentoTemplateIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports